export enum CustomerStatusEnum {
  Active = 'Active',
  Inactive = 'Inactive',
}
